import styled from '@emotion/styled'

export const Canvas = styled.canvas`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`